<template>
  <div class="container">
    <div class="header">
      <div class="box clearfix">
        <div class="nav logo fl">
          <img src="~@/assets/logo-b.png"
               alt="奇门排盘">
        </div>
        <div class="nav fl">
          <a class="a-home"
             href="/">首页</a>
        </div>
        <div class="nav button fr"  >
          <a href="#" v-popover:popover1><span>app下载</span></a>
        </div>
        <el-popover
          ref="popover1"
          placement="bottom" 
          width="120"
          trigger="hover">
          <div class="qrcode">
            <img style="width:120px; height: 120px;" src="~@/assets/qrcode.png"
                  alt="" />
          </div>
        </el-popover>
        <div class="nav fr">
          <b class="nav-login">
            <label v-if="!isLogin">
              <a href="#" @click="openModal">
                登录
              </a>
            </label>
            <label v-if="isLogin">
              <span class="user">您好！{{userName}}</span>
              <a class="logout" href="#" @click="logout">
                退出
              </a> 
            </label>
          </b>
          <a href="#" @click="gotobbs">
            <span>论坛</span>
          </a> 
        </div>
      </div>
    </div> 
    <router-view></router-view>
    <!-- <div class="footer-tools">
      <a href="/PrivacyPolicy">隐私条款</a>
    </div>  -->
    <v-modal :open.sync="showModal">
      <div class="modal"
           style="">
        <div class="title">
          <img src="~@/assets/taiji.png"
               alt=""> 
          <ol v-if="captchaType !== 'forget'">
            <li
              @click="changeType('login')" 
              :class="{isActive: captchaType === 'login'}">
              登录
            </li>
            <li
              @click="changeType('register')" 
              :class="{isActive: captchaType === 'register'}">
              注册
            </li>
          </ol>
          <p class="tabs active" v-if="captchaType === 'forget'">
            找回密码
          </p>
        </div>
        <div class="content">
          <table cellpadding="0"
                 cellspacing="0">
            <tbody>
              <tr>
                <td>
                  <input type="text"
                         v-model="mobile"
                         placeholder="请输入您的手机号码">
                </td>
                <td></td>
              </tr>
              <tr v-if="captchaType !== 'login'">
                <td>
                  <input type="text"
                         v-model="imgCode"
                         placeholder="请输入图形验证码">
                </td>
                <td>
                  <x-button type="mini"
                            width="130px"
                            @click="refreshCode">
                    <s-identify style="margin-top:3px;"
                                :identifyCode="identifyCode"
                                :contentWidth="80"
                                :contentHeight="30">
                    </s-identify>
                  </x-button>
                </td>
              </tr>
              <tr  v-if="captchaType !== 'login'">
                <td>
                  <input type="text"
                         v-model="captchaCode"
                         placeholder="请输入验证码">
                </td>
                <td> 
                  <x-button :type="sms.status == 1 ? 'h' : 'mini'"
                            width="130px"
                            @click="getSmsCode"
                            :text="smsBtnText" />
                </td>
              </tr> 
              <tr v-if="captchaType !== 'forget'">
                <td>
                  <input type="password"
                         v-model="password"
                         placeholder="请输入您的密码" autocomplete="new-password">
                </td>
                <td></td>
              </tr>
              <tr v-if="captchaType === 'forget'">
                <td>
                  <input type="password"
                        v-model="password" 
                        placeholder="请重置您的密码" autocomplete="new-password">
                </td>
                <td></td>
              </tr> 
            </tbody>
          </table>
          <div class="row">
            <x-button width="300px"
                      text="确定"
                      style="margin: 0 auto;"
                      @click="confirm" />
          </div>
          <div class="row" style="text-align: right; color：#999;">
            <label v-if="captchaType !== 'forget'" @click="changeType('forget')">忘记密码</label>
            <label v-if="captchaType === 'forget'" @click="changeType('login')">返回登录</label>
          </div>
        </div>
      </div>
    </v-modal>
  </div>
</template>

<script>
import xButton from '@/components/button'
import SIdentify from '@/components/identify'
import vModal from '@/components/VModal'
import service from '@/modules/service.js'
import utils from '@/modules/utils.js'

export default {
  components: {
    xButton,
    SIdentify,
    vModal
  },
  data () {
    return {
      identifyCode: "",
      identifyCodes: "5341",
      showModal: false,
      sms: {
        loading: false,
        status: 0,
        countDown: 0,
        timer: null
      },
      sendText: "发送验证码",
      sendRetry: "再次发送",
      interval: 60,
      isLogin: false,
      mobile: "",
      imgCode: "",
      captchaCode: "",
      captchaType: "login",
      tempToken: "",
      articleList: [],
      userName: "",
      activeTab: "hot",
      utils, 
      password: ""
    }
  },
  mounted () {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  computed: {
    smsBtnText () {
      if (this.sms.status === 0) {
        return this.sendText
      }
      if (this.sms.status === 2) {
        return this.sendRetry
      }
      return `${this.sendRetry}(${this.sms.countDown})`
    },
    token () {
      return utils.getCookie('qimenpan_token')
    }
  },
  methods: {
    changeTab(tabName) {
      this.activeTab = tabName
    },
    changeLoginTab(tabName) {
      this.loginTab = tabName
    },
    changeType (type) {
      this.captchaType = type;
      this.captchaCode = ""
      this.imgCode=""
      this.refreshCode()
    },
    openModal () {
      if (!this.isLogin) {
        this.modalClear()
        this.showModal = true; 
      } else { 
        location.href="http://bbs.qimenpan.com/" 
      }
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ""
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    confirm () {
      let params = {
        mobile: this.mobile,
        captcha: this.captchaCode,
        type: this.captchaType,
        token: this.tempToken,
        password: this.password
      }

      if (this.password.length > 30 || this.password.length < 6) {
        this.$message.warning('密码长度为6-30位。')
        return
      }

      const api = {
        "login": service.getLogin,
        "register": service.getRegister,
        "forget": service.forgetPassword
      } 

      if (this.captchaType === "login") {
        api[this.captchaType](params).then(res => {
          let data = res.data
          if (data.code === '0000') {
            utils.setCookie('qimenpan_token', data.info.token, 1)
            this.isLogin = true
            this.userName = utils.publicDesensitization(data.info.mobile)[0]
            this.showModal = false;
            this.modalClear() 
            console.log(data.msg)
          } else {
            console.log(data.msg)
          }
        })
      } else {
        if (this.identifyCode === this.imgCode) {
          api[this.captchaType](params).then(res => {
            let data = res.data
            if (data.code === '0000') { 
              this.changeType("login")
              console.log(data.msg)
            } else {
              this.$message.warning(data.msg)
            }
          })
        }
      }


      // if (this.identifyCode === this.imgCode) {
      //   service.getLogin({
      //     mobile: this.mobile,
      //     captcha: this.captchaCode,
      //     type: this.captchaType,
      //     token: this.tempToken
      //   })
      //     .then(res => {
      //       let data = res.data
      //       if (data.code === '0000') {
      //         utils.setCookie('qimenpan_token', data.info.token, 1)
      //         this.isLogin = true
      //         this.showModal = false;
      //         this.modalClear() 
      //         console.log(data.msg)
      //       } else {
      //         console.log(data.msg)
      //       }
      //     })
      // }
    },
    async getMobileCode () {
      let res = await service.getMobileCode()
      console.log({ res })
    },
    startCountDown () {
      clearInterval(this.sms.timer)
      this.sms.timer = setInterval(() => {
        this.sms.countDown -= 1
        if (this.sms.countDown <= 0) {
          this.sms.countDown = 0
          this.sms.status = 2
          clearInterval(this.sms.timer)
        }
      }, 1000)
    },
    clearCountDown () {
      this.sms.status = 0
      clearInterval(this.sms.timer)
    },
    async getSmsCode () {
      if (!this.mobile || !utils.isPhoneNumber(this.mobile)) {
        this.$message({
              message: "请输入正确的手机号",
              type: "warning"
            })
        return
      }
      if (this.identifyCode !== this.imgCode) { 
        this.$message({
              message: "图形验证码输入错误",
              type: "warning"
            })
        return
      }

      if (this.sms.status === 1 || this.sms.loading) {
        return false
      } 
      this.tempToken = ''
      this.sms.status = 1
      this.sms.loading = true
      let $this = this
      service.getMobileCode({
        mobile: this.mobile,
        type: this.captchaType
      })
        .then((res) => {
          let data = res.data
          console.log(res)
          if (data && data.code == '0000') {
            $this.sms.countDown = $this.interval
            $this.startCountDown()
            $this.tempToken = data.token
          } else {
            $this.sms.status = 0
          }
        })
        .catch(() => {
          this.clearCountDown()
        })
        .finally(() => {
          this.sms.loading = false
        })
    },
    checkLogin () {
      if (this.token) {
        service.checkLogin(this.token)
          .then(res => {
            if (res) {
              let data = res.data
              if (data.code === '0000') {
                utils.setCookie('qimenpan_token', this.token, 1)
                this.isLogin = true 
                this.userName = utils.publicDesensitization(data.mobile)[0]
              } else {  
                this.isLogin = false 
              }
            }
          })
      }
    },
    logout() { 
      if (this.token) {
        service.checkLogin(this.token)
          .then(res => {
            if (res) {
              let data = res.data
               if (data.code === '0000') {
                utils.setCookie('qimenpan_token', '', 1)
                // utils.deleteCookie('qimenpan_token')
                this.isLogin = false 
              }  
            }
          })
      } else {
        this.isLogin = false
      }
    },
    modalClear () {
      this.mobile = ""
      this.captchaCode = ""
      this.imgCode = ""
      this.loginTab = "login"
      this.password = ""
      this.refreshCode()
    },
    getArticleList () {
      service.getForumThread()
        .then(res => {
          let data = res.data
          if (data.code === '0000') { 
            this.articleList = data.list 
          } else { 
            this.$message({
              message: data.msg,
              type: "warning"
            })
          }
        })
    },
    gotobbs() {
      if (this.token) {
        location.href="http://bbs.qimenpan.com/" 
      } else {
        location.href="http://bbs.qimenpan.com/" 
      }
    }
  },
  async created () {
    this.checkLogin()
    this.getArticleList()  
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clearfix::after {
    display: block;
    content: "";
    clear: both;
  }
  .el-popover {
    min-width: 100px;
  }
  .el-tooltip__popper.custom {
    color:#99631A;
    background:#F8F0E6;
  } 
  .el-tooltip__popper.custom[x-placement^=left] {
    .popper__arrow {
      border-left-color: #F8F0E6; 
      &::after{
        border-left-color: #F8F0E6; 
      }
    }
  }
}


.container {
  height: 100vh;
  min-height: 880px;
  display: flex;
  flex-direction: column;
  background-image: url(../assets/bg.png);
  .box {
    width: 1245px;
    margin: 0 auto;
  }
  .header {
    height: 60px;
    line-height: 60px;
    flex: 0 0 auto;
    background: RGBA(168, 142, 103, 0.7);
    .nav {
      margin: 0 24px;
      a {
        text-decoration: none;
        color: #fff;
        font-size: 18px;
      }
      .a-home {
        color: #462700;
      }
      &.logo {
        margin-right: 100px;
      }
      &.button {
        margin-left: 40px;
        span {
          border: 1px solid #fff;
          border-radius: 5px;
          padding: 3px 10px;
        }
      }
      .nav-login {
        color: #fff;
        margin-right: 40px;
        font-weight: 500;
        .user {
          padding-right: 15px;
          border-right: 1.4px solid ;
        }
        .logout {
          padding-left: 12px;
        }
      }

    }
    .logo {
      img {
        vertical-align: middle;
      }
    }
  }
  .main {
    flex: 1 0 auto;
    color: #99631a;
    display: flex;
    align-items: center;
    .details { 
      position: relative;
      height: 754px;
      background-image: url(../assets/bg-main.png);
      .phone {
        margin-left: 5px;
        margin-top: 110px;
        width: 400px;
      }
      .explain {
        width: 225px;
        margin: 130px 15px 0;
        text-align: left;
        h3 {
          text-align: center;
        }
        p {
          line-height: 3em;
          font-size: 14px;
        }
        .qrcode {
          margin-top: 20px;
          img {
            width: 115px;
          }
        }
      }
      .bbs {
        margin-top: 90px;
        padding: 20px 10px;
        height: 488px;
        width: 490px;
        background-color: #f8f0e6;
        border-radius: 10px;
        box-shadow: 0 0 20px #ccc;
        .option {
          .x-button {
            margin: 0 auto;
          }
          .logout {
            margin: 26px;
            cursor: pointer;
            color: #999;
            text-align: right;
            text-decoration: underline;
          }
        }
        ul {
          margin: 10px 0 10px 2px;
          width: 330px;
          height: 300px;
          text-align: left;
          line-height: 3em;
          list-style-type: none;
          li {
            width: 400px;
            display:flex;
            justify-content: space-between;
            p {
              margin: 0;
              padding: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              label { 
                color: #f8f0e6;
                background: #99631a;    
                padding: 2px 4px;
                margin-right: 10px;
                font-size: 12px;
                border-radius: 2px;
              }
              a {
                text-decoration: none;
                color: #99631a;
              } 
            }
            span {
              color: #999;
            }
          }
        }
      }
      .flex-nav {
        position: absolute;
        right: -16px;
        bottom: 22px;
        height: 72px;
        width: 40px; 
        .tools {
          display: flex;
          align-items: center;
          justify-content: center; 
          margin: 4px;
          height: 32px;
          background:#99631A;
          border-radius: 3px;
        }
      }
    }
    .enter {
      margin-top: 15px;
      margin-bottom: 23px;
      padding: 1px;
      height: 157px;
      background-image: url(../assets/bg-bottom.png);
    }
    
    ol {
      height: 30px;
      list-style-type: none;
      li {  
        padding: 5px 10px;
        width: 50px;
        color:#AAAAAA;
        border-bottom: 1px solid;
        font-family:PingFang SC;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        &.isActive { 
          color: #99631a; 
        }
      }
    }
  }
  .footer {
    flex: 0 0 auto;
    height: 54px;
    line-height: 54px;
    background: #212121;
    color: #999;
    font-size: 14px;
  }
  .footer-tools {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 0 5px;
    background: #99631A;
    font-size: 14px;
    a {
      color: #fff;
    }
  }
  .modal {
    padding: 30px;
    width: 550px;
    background-color: #f8f0e6;
    border-radius: 10px;
    .title {
      padding: 20px 0;
      color: #99631a;
      .tabs {
        cursor: default; 
        font-weight: 600; 
      }
    }
    .content {
      table {
        width: 315px;
        margin: 0 auto;
        text-align: left;
        tr {
          height: 50px;
          td {
            border-bottom: 1px solid #999;
            border-collapse: collapse;
            input[type="text"],input[type="password"] {
              line-height: 37px;
              border: 0; // 去除未选中状态边框
              outline: none; // 去除选中状态边框
              background-color: #f8f0e6 !important; // 透明背景
            }
          }
        }
      }
      .row {
        width: 315px;
        margin: 0 auto;
        label {
          color: #999;
        }
      }
    }
    .row {
      padding-top: 10px;
      padding-bottom: 10px;
      height: 40px;
    }
    
    ol {
      display: flex;
      padding: 0;
      justify-content: center;
      height: 30px;
      list-style-type: none;
      li {  
        padding: 5px 20px;
        width: 50px;
        color:#AAAAAA;
        border-bottom: 1px solid;
        font-family:PingFang SC;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        &.isActive { 
          color: #99631a; 
        }
      }
    }
  }
}
</style>